import React, { useEffect } from 'react'
import { ThemeProvider } from 'styled-components'
import { GlobalStyles } from './Style/globalStyles'
import { useDarkMode } from './Style/useDarkMode'
import { lightTheme, darkTheme } from './Themes'
import * as PropTypes from 'prop-types'
import Brightness4Icon from '@material-ui/icons/Brightness4'

const Toggle = ({ toggleTheme }) => {
  return <Brightness4Icon fontSize="small" onClick={toggleTheme} />
}
Toggle.propTypes = {
  theme: PropTypes.string.isRequired,
  toggleTheme: PropTypes.func.isRequired
}
const Theme = () => {
  const [theme, themeToggler] = useDarkMode()
  const themeMode = theme === 'dark' ? darkTheme : lightTheme

  useEffect(() => {
    const timer = setTimeout(() => {}, 1)
    return () => clearTimeout(timer)
  }, [])
  // if (!mountedComponent) return <div />;
  return (
    <ThemeProvider theme={themeMode}>
      <GlobalStyles />
      <Toggle className="dark" theme={theme} toggleTheme={themeToggler} />
    </ThemeProvider>
  )
}

export default Theme
